import {
    Box,
    BoxProps,
    ExpansionPanelDetails,
    Grid,
    IconButton,
    ExpansionPanel as MuiExpansionPanel,
    ExpansionPanelProps as MuiExpansionPanelProps,
    Typography,
} from '@material-ui/core'

import React from 'react'
import { contentPadding } from '~/styles/sizes'
import styled from 'styled-components'

export const TitleRow = styled(Typography)`
    ${({ theme }) => `
        padding-top: ${theme.spacing(contentPadding)};
        padding-left: ${theme.spacing(contentPadding)};
    `}
`

export const HomeLink = styled(Box)`
    color: black;
`

export const TopLevelNavBox = styled(Box)`
    position: relative;
`

type ExpansionPanelProps = MuiExpansionPanelProps & {
    isTransparent: boolean
}

export const ExpansionPanel = styled(({ isTransparent, ...rest }: ExpansionPanelProps) => (
    <MuiExpansionPanel {...rest} />
))`
    ${({ isTransparent }: ExpansionPanelProps) => `
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 1300;
        box-shadow: none;
        margin-bottom: 0 !important;
        background-color: rgba(255, 255, 255, ${isTransparent ? 0.15 : 1});
        backdrop-filter: blur(10px);
    `}
`

export const TitleContainer = styled(Grid)`
    ${({ theme }) => `
        height: ${theme.spacing(15)};
    `}
`

export const ExpandingLinks = styled(ExpansionPanelDetails)`
    ${({ theme }) => `
        padding-left: ${theme.spacing(contentPadding)};
        padding-bottom: ${theme.spacing(contentPadding)};
    `}
`

export const ExpandButton = styled(IconButton)`
    ${({ theme }) => `
        padding: ${theme.spacing(contentPadding)};;
    `}
`

export const MobilePageNav = styled(Box)`
    ${({ theme }) => `
        padding-bottom: ${theme.spacing(contentPadding)};
    `}
`

type InstitutionsHideShowProps = BoxProps & {
    isVisible: boolean
}

export const InstitutionsHideShow = styled(({ isVisible, ...rest }: InstitutionsHideShowProps) => (
    <Box {...rest} />
))`
    ${({ isVisible }: InstitutionsHideShowProps) => `
        opacity: ${isVisible ? 1 : 0};
        transition: opacity 0.2s linear;
    `}
`

export const FundingLogo = styled.img`
    ${({ theme }) => `
        margin-top: ${theme.spacing(2)};
        margin-right: ${theme.spacing(2)};
        height: ${theme.spacing(20)};
    `}
`
